import type {ReactElement} from 'react';
import {FontSizeControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/font-size-control/font-size-control';
import {LABEL_SIZES} from '@FormMakerReact/layout/form-maker-right-panel/sectors/label-sector/label-sector.types';
import type {LabelSizeControlProps} from './label-size-control.types';

export function LabelSizeControl({component}: LabelSizeControlProps): ReactElement {
  return <FontSizeControl component={component} sizes={LABEL_SIZES} />;
}
